module.exports = __webpack_public_path__ + "static/media/logo-kr.3cdcb503.png";